import { useState } from "react"

const useToggle = (initialState = false) => {
  const [isToggled, setToggle] = useState(initialState)
  const toggle = () => setToggle(isToggled => !isToggled)
  return [isToggled, toggle]
}

export default useToggle
